import Vue from 'vue';
import DEFINES from'@/defines'

Vue.filter ('capitalize', function (value) {
  if (!value) return '';
  value = value.toString ();
  return value.charAt (0).toUpperCase () + value.slice (1);
});

Vue.filter ('published', function (items) {
  if (!items) return '';
  return items.filter (item => item.is_published == true);
});

Vue.filter ('truncate', function (value, length = 25, clamp = '...') {
  if (!value) return '';
  value = value.toString ();
  return value.length > length ? value.substr (0, length - 1) + clamp : value;
});

Vue.filter ('fixed', function (value, decimal = 2) {
  if (!value) return 0;
  value = parseFloat (value);
  return value.toFixed (decimal);
});

/**
 * Filter screening and VOD events by is_vod_event flag
 */
Vue.filter ('EventType', function (items, type) {
  if (!items) return '';
  // Filter all standard events dynamically
  if(type == DEFINES.EVENT_TYPE.VOD_EVENTS) return items.filter (item => item.is_vod_event == true);

  // Filter all vod events dynamically
  if(type == DEFINES.EVENT_TYPE.STANDARD_EVENTS) return items.filter (item => item.is_vod_event == false);
});

/**
 * Filter screening and VOD events by is_vod_event flag
 */
 Vue.filter ('PhysicalEvents', function (items, type) {
  if (!items) return '';
  return items.filter (item => item.event_type == DEFINES.SCREENER_TYPE.PHYSICAL);
});

Vue.filter ('VirtualEvents', function (items) {
  if (!items) return '';
  return items.filter (item => item.event_type == DEFINES.SCREENER_TYPE.VIRTUAL);
});

Vue.filter ('VirtualAndPhysical', function (items) {
  if (!items) return '';
  return items.filter (item => item.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL);
});

